angular.module('unica_invitation_transfer.invitation_transfer_controllers')

.controller('InvitationTransferEditController', function(
	$rootScope, $scope, $state, $stateParams,
	InvitationTransferEditService
) {
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getTransferList( $stateParams.event_id );
//
//	$rootScope.getInvitationsByEvent( $stateParams.event_id );

	$rootScope.getInvitationTransfer( $stateParams.id );

	$rootScope.invitationTransferData = {
		event_id: $stateParams.event_id
	};

	$scope.saveInvitationTransfer = function() {
		$scope.showLoader();

		var invitationTransferData = angular.copy($rootScope.invitationTransferData);
		invitationTransferData = $scope.parseInvitationTransferFromDateToTimestamp(invitationTransferData);

		InvitationTransferEditService
			.update( invitationTransferData )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.showSuccessMsg('Aggiornamento Configurazione Transfer avvenuto con successo!', '');
				} else {
					$rootScope.manageError(data);
				}
			});
	};

});
